<template>
    <div v-if="visible">
        <el-dialog title="校友会" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="800px">    
           
            <div style="display: inline-block; height:40px;"> 
                <el-input v-model="form.graduationGradename" placeholder="年级学级"></el-input>
            </div>
            <div style="display: inline-block; height:40px;"> 
                <el-date-picker style="width: 140px;"
                    v-model="form.startDate"
                    type="date"
                    placeholder="开始日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
            </div>
            <div style="display: inline-block; height:40px;">
                <el-date-picker style="width: 140px;"
                    v-model="form.endDate"
                    type="date"
                    placeholder="结束日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd">
                </el-date-picker> 
            </div>
            <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
            <el-table
                :data="data"
                row-key="id"
                height="450"
                v-loading="loading"
                :element-loading-text="loadingText"
                element-loading-background = "rgba(255, 255,255,0.7)"
                style="width: 100%">
                    <el-table-column type="index" fixed label="序号" width="55px" :index="indexMethod"> </el-table-column>
                    <el-table-column property="graduationGradename" label="年级学级" ></el-table-column>
                    <el-table-column property="" :formatter="formatDate" label="年级时间" width="110"></el-table-column>
                    <el-table-column fixed="right" label="操作"  width="100"> 
                        <template slot-scope="scope">
                            <el-button
                                @click.native.prevent="exportData(scope.row)"
                                type="text"
                                size="small">
                                <span style="color: #387EE8;">{{ (scope.row.status == 2 && scope.row.archiveDataUrl) ? '下载校友录' : '导出校友录' }}</span>
                            </el-button>
                        </template>
                    </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import axios from 'axios';
    import http from '../../../../../common/http';

    export default {
        name:"",
        data(){
            return{
                visible: false,
                loading:false,
                loadingText:"",
                form:{
                    graduationGradename:"",
                    startDate:"",
                    endDate:""
                },
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                data:[],
            }
        },
        components: {
        },
        created:function () {
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1)
            },
            init(){
                this.visible=true
                this.form.graduationGradename = ""
                this.form.startDate = ""
                this.form.endDate = ""
                
                this.getData()
            },
            getData(){
                let url  = this.archiveAlumniAssociationListUrl
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    graduationGradename:this.form.graduationGradename,
                    startDate: this.form.startDate,
                    endDate: this.form.endDate
                };

                this.loading=true
                this.loadingText="数据在加载中..."

                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.data = res.data.list
                        this.common.total=res.data.total
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                    this.loading=false
                },(err)=>{
                    console.log(err)
                    this.loading=false
                });
            },
            formatDate(row) {
                let date = new Date(row.graduationDate)
                let tt = [date.getFullYear(), date.getMonth()+1, date.getDate()].join('-')
                return tt
            },
            dialogClose(done){
                done()
                this.$reload
            },
            handleSizeChange(val) {
                this.common.pageSize = val
                this.common.page = 1
                this.getData()
            },
            handleCurrentChange(val) {
                this.common.page = val
                this.getData()
            },
            // 导出校友录
            exportData(row){
                let date = new Date(row.graduationDate)
                let tt = [date.getFullYear(), date.getMonth()+1, date.getDate()].join('-')
                let filename=row.graduationGradename+"("+tt+")"

                // status为2且archiveDataUrl有值，直接下载zip（走后端代理接口，避免跨域）
                if(row.status == 2 && row.archiveDataUrl){
                    this.loading=true
                    this.loadingText="正在下载中，下载过程时间可能会比较长，请耐心等待"

                    let zipUrl = this.archiveAlumniAssociationDownloadZipUrl
                    let param = new URLSearchParams()
                    param.append('id', row.id)

                    axios({
                        method: "post",
                        url: zipUrl,
                        data: param,
                        responseType: "blob"
                    }).then(res => {
                        const link = document.createElement("a")
                        let blob = new Blob([res.data], { type: "application/zip" })
                        link.style.display = "none"
                        link.href = URL.createObjectURL(blob)
                        link.setAttribute("download", filename+'.zip')
                        document.body.appendChild(link)
                        link.click()
                        document.body.removeChild(link)
                        this.loading=false
                    }).catch(error => {
                        console.log(error)
                        this.loading=false
                    })
                }else{
                    this.loading=true
                    this.loadingText="正在导出中，导出过程时间可能会比较长，请耐心等待"

                    let url=this.archiveAlumniAssociationExportExcelUrl
                    let param = new URLSearchParams()
                    param.append('id', row.id)

                    axios({
                        method: "post",
                        url: url,
                        data: param,
                        responseType: "blob"
                    }).then(res => {
                        const link = document.createElement("a")
                        let blob = new Blob([res.data], { type: "application/vnd.ms-excel" })
                        link.style.display = "none"
                        link.href = URL.createObjectURL(blob)
                        link.setAttribute("download", filename+'.xls')
                        document.body.appendChild(link)
                        link.click()
                        document.body.removeChild(link)
                        this.loading=false
                    }).catch(error => {
                        console.log(error)
                        this.loading=false
                    })
                }
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/sys/dept/association/List.vue